import { createAction } from "redux-act";

export const REQActiList = createAction("REQUEST_ACTI_LIST");
export const RESActiList = createAction("RECEIVE_ACTI_LIST");
export const FailRegisActiList = createAction("FAILED_ACTI_LIST");
export const CleanUpActiList= createAction("CLEANUP_ACTI_LIST");